import React from 'react';

interface IFilterOption {
    label: string;
    value: string;
}

interface IDateFilterGroupProps {
    activeValue: string;
    className: string;
    options: IFilterOption[];
    onChange: (value: string) => void;
}

export const DateFilterGroup: React.FC<IDateFilterGroupProps> = ({ options, activeValue, onChange, className }) => {
    return (
        options && (
            <div className={`${className}__date-filter-section`}>
                {options.map(({ label, value }) => {
                    const isActive = activeValue === value;
                    return (
                        <button
                            key={value}
                            className={`${className}__date-filter-section-button ${isActive ? 'msc-cta__primary' : 'msc-cta__secondary'}`}
                            onClick={() => onChange(value)}
                        >
                            {label}
                        </button>
                    );
                })}
            </div>
        )
    );
};
